export default "__VITE_ASSET__hhsn5a0N__"